import React from 'react';
import { Form } from 'ALIASED-antd';
import styled from '@emotion/styled';
import { TRegistrationForm } from './TRegistrationForm';

type RegistrationFormItemType = typeof Form.Item<TRegistrationForm>;
export type RegistrationFormItemProps = React.ComponentProps<RegistrationFormItemType>;

const StyledFormItem = styled<RegistrationFormItemType>(Form.Item)`
  .ant-row {
    display: block;
  }
`;

const defaultProps: Partial<RegistrationFormItemProps> = {
  colon: false,
  preserve: true
};

export const RegistrationFormItem = (props: RegistrationFormItemProps) => {
  const { label, ...restProps } = props;
  // Wrap string labels in <span> to prevent Ant Design from adding title attributes that cause accessibility warnings
  const labelElement = typeof label === 'string' ? <span>{label}</span> : label;

  return <StyledFormItem {...defaultProps} {...restProps} label={labelElement} />;
};
